import { Injectable } from '@angular/core';
import { APP_CONST } from '../../app.const';
import { RequestService } from '../../libraries/http/request.service';

@Injectable()
export class CreditNoteRestService {
  baseURL = `${APP_CONST.API_MASTER}/admin/credit-note`;
  request = this._request.new(this.baseURL);

  constructor(private _request: RequestService) {}

  findAll(queryParams: any = {}) {
    return this.request.get<any>(`/`, { params: queryParams });
  }

  getByDealerId(dealerId: string, queryParams: any = {}) {
    return this.request.get<any>(`/dealer-history/${dealerId}`, { params: queryParams });
  }

  create(data: {
    mainDealerId: string;
    date: string;
    category: string;
    quantity: number;
    revenue: number;
    deductedAmount: number;
    remainingCredit: number;
    note: string;
  }) {
    return this.request.post<any>(`/`, data);
  }
}
